const STATUS_STYLES = {
  pending:     'bg-gray-100 text-gray-600',
  in_progress: 'bg-blue-100 text-blue-700',
  review:      'bg-yellow-100 text-yellow-700',
  completed:   'bg-green-100 text-green-700',
  blocked:     'bg-red-100 text-red-700',
}
const STATUS_LABELS = {
  pending:     'Pendiente',
  in_progress: 'En Progreso',
  review:      'En Revisión',
  completed:   'Completado',
  blocked:     'Bloqueado',
}
const PRIORITY_STYLES = {
  low:    'bg-gray-100 text-gray-500',
  medium: 'bg-yellow-100 text-yellow-700',
  high:   'bg-red-100 text-red-700',
}
const PRIORITY_LABELS = { low: 'Baja', medium: 'Media', high: 'Alta' }

export function StatusBadge({ status }) {
  return (
    <span className={`badge ${STATUS_STYLES[status] ?? STATUS_STYLES.pending}`}>
      {STATUS_LABELS[status] ?? status}
    </span>
  )
}

export function PriorityBadge({ priority }) {
  return (
    <span className={`badge ${PRIORITY_STYLES[priority] ?? PRIORITY_STYLES.medium}`}>
      {PRIORITY_LABELS[priority] ?? priority}
    </span>
  )
}

export function MacroBadge({ macro }) {
  const styles = {
    strategic_plan: 'bg-brand-100 text-brand-700',
    tactical_plan:  'bg-amber-100 text-amber-700',
    execution:      'bg-green-100 text-green-700',
  }
  const labels = {
    strategic_plan: 'Plan Estratégico',
    tactical_plan:  'Plan Táctico',
    execution:      'Ejecución',
  }
  return (
    <span className={`badge ${styles[macro] ?? 'bg-gray-100 text-gray-600'}`}>
      {labels[macro] ?? macro}
    </span>
  )
}
